import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, CardTitle } from '../../../../ui-kit';
import { Placeholder } from '../Placeholder';
import { useFromToContext } from '../../../shared';
import { CancelationsDiscountsVoidedComponent, DateFromTo } from '../../../../generated/graphql';
import { routePaths } from '../../../../routePaths';
import DetailCard from './DetailCard';

const CancelVoidDiscount = () => {
    const { t } = useTranslation();
    const { dateFromTo } = useFromToContext();
    const history = useHistory();

    const handleNavigateToDiscountedBills = () => {
        const searchParamString = new URLSearchParams({ discounted: '1' }).toString();
        const path = `${routePaths.bills}?${searchParamString}`;
        history.push(path);
    };

    const handleNavigateToVoidedBills = () => {
        const searchParamString = new URLSearchParams({ voided: '1' }).toString();
        const path = `${routePaths.bills}?${searchParamString}`;
        history.push(path);
    };

    const handleNavigateToCancelledOrders = () => {
        const searchParamString = new URLSearchParams({ cancelled: '1' }).toString();
        const path = `${routePaths.orders}?${searchParamString}`;
        history.push(path);
    };

    return (
        <CancelationsDiscountsVoidedComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={260} />}
        >
            {({ data: { canceledOrderLines, voidedBills, discountedOrderLines, } }) => (
                <Card fullHeight>
                    <CardContent padding={3}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <CardTitle>{t('Cancelations, discounts, voided bills')}</CardTitle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <DetailCard
                                    title={t('Cancelations')}
                                    value={canceledOrderLines.canceledValue}
                                    itemsCount={canceledOrderLines.itemCount}
                                    onClick={handleNavigateToCancelledOrders}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <DetailCard
                                    title={t('Discounts')}
                                    value={discountedOrderLines.discountedValue}
                                    itemsCount={discountedOrderLines.itemCount}
                                    onClick={handleNavigateToDiscountedBills}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <DetailCard
                                    title={t('Voided bills')}
                                    value={voidedBills.voidedValue}
                                    itemsCount={voidedBills.itemCount}
                                    onClick={handleNavigateToVoidedBills}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            )}
        </CancelationsDiscountsVoidedComponent>
    );
};
export default CancelVoidDiscount;
